export const StepEnum = {
    mainText:'mainText',
    textField:'textField',
    firstDividedTextList:'firstDividedTextList',
    secondDividedTextList:'secondDividedTextList',
    createImgText:'createImgText',
    contentImage : 'contentImage',
}

export const LangType = {
    KO: "KO",
    EN: "EN",
    JA: "JA",
    ZH: "ZH",
}

export const TranslationLangType = {
    TH: "TH",
    VN: "VN",
    MN: "MN",
    ID: "ID",
    RU: "RU",
    TW: "TW"
};

export const TranslationLangTypes = ["TH", "VN", "MN", "ID", "RU", "TW"];

export const TranslationLangName = {
    TH: "태국어",
    VN: "베트남어",
    MN: "몽골어",
    ID: "인도네시아어",
    RU: "러시아어",
    TW: "대만어(번체)"
}
export const FAQLangName = {
    EN: {
        KO:'Korean',
        EN:'English',
        JA:'Japanese',
        ZH:'Chinese',
        TH:'Thai',
        VN:'Vietnamese',
        MN:'Mongolian',
        ID:'Indonesian',
        RU:'Russian',
        TW:'Taiwanese',
    },
    KO :{
        KO:'한국어',
        EN:'영어',
        JA:'일본어',
        ZH:'중국어',
        TH:'태국어',
        VN:'베트남어',
        MN:'몽골어',
        ID:'인도네시아어',
        RU:'러시아어',
        TW:'대만어',

    }
}

export const NoticeLangName = {
    EN: {
        KO:'Korean',
        EN:'English',
        JA:'Japanese',
        ZH:'Chinese',
        TH:'Thai',
        VN:'Vietnamese',
        MN:'Mongolian',
        ID:'Indonesian',
        RU:'Russian',
        TW:'Taiwanese',
    },
    KO :{
        KO:'한국어',
        EN:'영어',
        JA:'일본어',
        ZH:'중국어',
        TH:'태국어',
        VN:'베트남어',
        MN:'몽골어',
        ID:'인도네시아어',
        RU:'러시아어',
        TW:'대만어',

    }
}

